export enum MessageActionEnum {
  Save = 'save',
  Delete = 'delete',
  Upload = 'upload',
  Sent = 'sent',
  Create = 'create'
}
